import type { DetailPageConfig } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { Tickets } from "@/src/gql/graphql";
import { ticketDetailActions } from "@/lib/actions/definitions/entities";

// ============================================================================
// TICKET DETAIL PAGE CONFIGURATION
// ============================================================================

export const ENHANCED_TICKET_DETAIL_CONFIG: DetailPageConfig<Tickets> = {
  entity: "tickets",
  displayName: "Ticket",

  // Tab configurations
  tabs: [
    {
      id: "details",
      label: "Details",
      icon: "ticket",
      variant: "blue",
      group: "core",
      priority: 1,
      clientVisible: true,
      content: {
        type: "custom",
        customComponent: "TicketDetails",
      },
    },
    {
      id: "company",
      label: "Company",
      icon: "building",
      variant: "red",
      group: "related",
      priority: 1,
      clientVisible: true,
      visible: (item: Tickets) => !!(item as any).company_id || !!(item as any).company_name,
      content: {
        type: "custom",
        customComponent: "TicketCompanyDisplay",
      },
    },
    {
      id: "contact",
      label: "Contact",
      icon: "user",
      variant: "blue",
      group: "related",
      priority: 2,
      clientVisible: true,
      visible: (item: Tickets) => !!(item as any).contact_id || !!(item as any).contact_name,
      content: {
        type: "custom",
        customComponent: "TicketContactDisplay",
      },
    },
    {
      id: "time-entries",
      label: "Time Entries",
      icon: "clock",
      variant: "purple",
      group: "related",
      priority: 3,
      clientVisible: true,
      content: {
        type: "custom",
        customComponent: "TicketTimeEntriesDisplay",
      },
    },
    {
      id: "tasks",
      label: "Tasks",
      icon: "check-square",
      variant: "green",
      group: "activity",
      priority: 2,
      content: {
        type: "custom",
        customComponent: "TicketTasksDisplay",
      },
    },
    {
      id: "updates",
      label: "Updates",
      icon: "message-square",
      variant: "green",
      group: "activity",
      priority: 1,
      clientVisible: true,
      content: {
        type: "custom",
        customComponent: "TicketUpdates",
      },
    },
    {
      id: "activity",
      label: "Activity",
      icon: "activity",
      variant: "purple",
      group: "activity",
      priority: 3,
      content: {
        type: "custom",
        customComponent: "TicketActivityTimeline",
      },
    },
    {
      id: "attachments",
      label: "Attachments",
      icon: "paperclip",
      variant: "purple",
      group: "resources",
      priority: 1,
      clientVisible: true,
      content: {
        type: "custom",
        customComponent: "TicketAttachments",
      },
    },
  ],

  // Action configurations - from centralized registry
  actions: ticketDetailActions,

  // Breadcrumb configuration
  breadcrumbs: {
    show: true,
    items: [
      { label: "Tickets", href: "/tickets" },
      {
        label: "Ticket Details",
        href: (ticket: Tickets) => `/tickets/${ticket.id}`,
        current: true,
      },
    ],
  },

  // Page configuration
  defaultTab: "details",
  showHeader: true,
  showBreadcrumbs: true,
  showActions: true,

  // Title and description templates
  titleTemplate: (ticket: Tickets) => ticket.title,
  descriptionTemplate: (ticket: Tickets) => ticket.ticket_number.toString(),
};
